import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAdtMessage } from "app/services/adt/adtService";
import { BASE_URL } from "static/constants";

export const adtApi = createApi({
  reducerPath: "adtApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    downloadAdt: builder.query({
      queryFn: (filename) => ({
        data: getAdtMessage(filename),
      }),
    }),
  }),
});

export const { useDownloadAdtQuery } = adtApi;
